import React from 'react';
import Grid from '@mui/material/Grid2';
import { observer } from 'mobx-react';
import dashboardStore from 'store/dashboardStore';
import PieChartWidget from './widget/PieChartWidget';
import M from 'messages';

const PieChartSection = observer(() => (
  <Grid container spacing={2} sx={{ mt: 3 }}>
    <Grid size={{ xs: 12, md: 4 }}>
      <PieChartWidget
        title={M.get('dashboard.wineViewsBySweetness')}
        data={dashboardStore.viewsBySweetness}
        tooltip={M.get('dashboard.wineViewsBySweetnessTooltip')}
        loading={dashboardStore.viewsBySweetnessLoading}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 4 }}>
      <PieChartWidget
        title={M.get('dashboard.wineViewsByColor')}
        data={dashboardStore.viewsByColor}
        tooltip={M.get('dashboard.wineViewsByColorTooltip')}
        loading={dashboardStore.viewsByColorLoading}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 4 }}>
      <PieChartWidget
        title={M.get('dashboard.wineViewsByStyle')}
        data={dashboardStore.viewsByStyle}
        tooltip={M.get('dashboard.wineViewsByStyleTooltip')}
        loading={dashboardStore.viewsByStyleLoading}
      />
    </Grid>
  </Grid>
));

export default PieChartSection;
